import { ComparabilitySearchComparableTaxpayer } from './comparability-search-comparable-taxpayer';
import { ComparabilitySearchInitialRangeResults } from './comparability-search-initial-range-results';
import { Collapsible } from '../interfaces';

export class ComparabilitySearchSingleYear implements Collapsible {
  comparableTaxPayer: ComparabilitySearchComparableTaxpayer;
  initialRangeResults: ComparabilitySearchInitialRangeResults;
  collapsed: boolean;
}
